// @flow

// State Configuration
export const TREE = 'auth'

// Action Types
export const LOGIN = '@@fc-auth/LOGIN'
export const FETCH_TOKEN = '@@fc-auth/FETCH_TOKEN'
export const RECEIVE_TOKEN = '@@fc-auth/RECEIVE_TOKEN'
export const TOKEN_FETCH_FAIL = '@@fc-auth/TOKEN_FETCH_FAIL'
export const REMOVE_CREDENTIALS = '@@fc-auth/REMOVE_CREDENTIALS'
export const CREDENTIALS_REMOVED = '@@fc-auth/CREDENTIALS_REMOVED'
export const IS_BOOTING = '@@fc-auth/IS_BOOTING'
export const REQUEST_RESET_PASSWORD = '@@fc-auth/REQUEST_RESET_PASSWORD'
export const RESET_PASSWORD = '@@fc-auth/RESET_PASSWORD'
// Urls
export const URL_TOKEN = '/token'
export const URL_TOKEN_LOGIN = '/hefty/token-login'
export const URL_RESET_PASSWORD = 'client/password/reset/change'
